import React from 'react';
import './css/pagination.css';

/**
 * Reusable pagination bar.
 * Props:
 *   page            – current 1-based page number
 *   totalPages      – total number of pages
 *   totalItems      – total item count (for "Showing X–Y of Z")
 *   pageSize        – items per page
 *   onPageChange    – (newPage: number) => void
 *   onPageSizeChange – (newSize: number) => void
 */
function Pagination({ page, totalPages, totalItems, pageSize, onPageChange, onPageSizeChange }) {
  if (totalItems === 0) return null;

  // Build page number list with ellipsis
  const buildPages = () => {
    const pages = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      pages.push(1);
      if (page > 3) pages.push('...');
      for (let i = Math.max(2, page - 1); i <= Math.min(totalPages - 1, page + 1); i++) {
        pages.push(i);
      }
      if (page < totalPages - 2) pages.push('...');
      pages.push(totalPages);
    }
    return pages;
  };

  const from = Math.min((page - 1) * pageSize + 1, totalItems);
  const to   = Math.min(page * pageSize, totalItems);
  const pages = buildPages();

  return (
    <div className="pg-bar">
      <span className="pg-info">
        Showing <strong>{from}–{to}</strong> of <strong>{totalItems}</strong>
      </span>

      <div className="pg-controls">
        <select
          className="pg-size"
          value={pageSize}
          onChange={(e) => { onPageSizeChange(Number(e.target.value)); onPageChange(1); }}
        >
          {[10, 25, 50].map((s) => (
            <option key={s} value={s}>{s} / page</option>
          ))}
        </select>

        <button className="pg-btn" onClick={() => onPageChange(page - 1)} disabled={page === 1}>‹</button>

        {pages.map((p, i) =>
          p === '...' ? (
            <span key={`el-${i}`} className="pg-ellipsis">…</span>
          ) : (
            <button
              key={p}
              className={`pg-btn${page === p ? ' active' : ''}`}
              onClick={() => onPageChange(p)}
            >
              {p}
            </button>
          )
        )}

        <button className="pg-btn" onClick={() => onPageChange(page + 1)} disabled={page >= totalPages}>›</button>
      </div>
    </div>
  );
}

export default Pagination;
